export default "__VITE_ASSET__Cgs3T8w8__"